import { gql } from "@apollo/client";

export const GET_CHART_EVENT_SEAT_STATES = gql`
  query ChartEventSeatStates($chartEventId: ID!, $holdToken: String) {
    chartEventSeatStates(chartEventId: $chartEventId, holdToken: $holdToken) {
      seatId
      status
      mine
      holdExpiresAt
    }
  }
`;
 
export const GET_CHART_EVENT_TICKET_TYPE_AVAILABILITY = gql`
  query ChartEventTicketTypeAvailability($chartEventId: ID!) {
    chartEventTicketTypeAvailability(chartEventId: $chartEventId) {
      ticketTypeId
      availableSeats
    }
  }
`;